export const specialtiesInCity = [
  { name: 'Cardiologista', slug: 'cardiologista' },
  { name: 'Clínico Geral', slug: 'clinico-geral' },
  { name: 'Dermatologista', slug: 'dermatologista' },
  { name: 'Geriatra', slug: 'geriatra' },
  { name: 'Ginecologista', slug: 'ginecologista' },
];
